module.exports = {
      id: "logos:nswgov-inverse-usage",
      viewBox: "0 0 35 38",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#logos:nswgov-inverse-usage",
      toString: function () {
        return this.url;
      }
    }